'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'compass-drafting';
var width = 512;
var height = 512;
var aliases = ["drafting-compass"];
var unicode = 'f568';
var svgPathData = 'M282.3 154.3l-.2-.3 13-7.4c15.1-11.7 24.8-30 24.8-50.6c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 20.6 9.7 38.9 24.8 50.6l13 7.4-.2 .3c8 3.6 17 5.7 26.3 5.7s18.3-2 26.3-5.7zm15.9 27.9c-12.8 6.3-27.1 9.8-42.3 9.8s-29.5-3.5-42.3-9.8L142.2 307.4C176.1 325.6 214.8 336 256 336c88.8 0 166.4-48.2 207.9-120l27.7 16c-47 81.3-134.9 136-235.6 136c-47 0-91.1-11.9-129.7-32.8L29.9 503.9 2.1 488.1l97-169.8c-32.1-22.7-59-52.1-78.7-86.2l27.7-16c16.9 29.2 39.8 54.6 67 74.3l72.5-126.9C170.5 146.1 160 122.3 160 96c0-53 43-96 96-96s96 43 96 96c0 26.3-10.5 50.1-27.6 67.4l56.5 98.9c-8.5 6.4-17.5 12.2-27 17.2l-55.6-97.4zM482.1 503.9L401.5 363c9.4-5.1 18.5-10.7 27.3-16.8l81.1 141.9-27.8 15.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCompassDrafting = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;